document.addEventListener('DOMContentLoaded', function() {
  const specialsLink = document.querySelector('li.header__menu_li a[href*="special-offers"]');
  if (!specialsLink) return;
  const li = specialsLink.closest('li');
  li.style.position = 'initial';
  const template = document.getElementById('special-offers-popup-template');
  if (!template) return;
  const popup = template.firstElementChild.cloneNode(true);
  const items = popup.querySelectorAll('.special-offer-item');
  const track = document.createElement('div');
  track.className = 'special-offers-track';
  items.forEach(item => track.appendChild(item));
  popup.appendChild(track);
  //  navigation buttons
  const prevBtn = document.createElement('button');
  const nextBtn = document.createElement('button');
  prevBtn.className = 'special-offers-prev';
  nextBtn.className = 'special-offers-next';
  prevBtn.innerHTML = '‹';
  nextBtn.innerHTML = '›';
  popup.appendChild(prevBtn);
  popup.appendChild(nextBtn);

  li.appendChild(popup);
  const button = popup.querySelector('.button');
  popup.appendChild(button);
 
  li.addEventListener('mouseenter', () => popup.classList.add('visible'));
  li.addEventListener('mouseleave', () => popup.classList.remove('visible'));
 
  function getItemsPerView() {
  if (window.innerWidth <= 480) return 1;
  if (window.innerWidth <= 650) return 2;
  if (window.innerWidth <= 900) return 3;
  return 4;
}
 function getItemsPerView() {
  if (window.innerWidth <= 480) return 1;
  if (window.innerWidth <= 650) return 2;
  if (window.innerWidth <= 900) return 3;
  return 4;
}

let itemsPerView = getItemsPerView();
let currentIndex = 0;

function updateSlide() {
  track.style.transform = `translateX(-${(100 / itemsPerView) * currentIndex}%)`;
}

window.addEventListener('resize', () => {
  itemsPerView = getItemsPerView();
  updateSlide();
});

function goNext() {
  const maxIndex = Math.max(items.length - itemsPerView, 0);
  currentIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
  updateSlide();
}

function goPrev() {
  const maxIndex = Math.max(items.length - itemsPerView, 0);
  currentIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
  updateSlide();
}
  prevBtn.addEventListener('click', goPrev);
  nextBtn.addEventListener('click', goNext);

  let autoSlide = setInterval(goNext, 2000);
  popup.addEventListener('mouseenter', () => clearInterval(autoSlide));
  popup.addEventListener('mouseleave', () => autoSlide = setInterval(goNext, 2000));
});


